import React, {FC, memo, useState} from 'react';
import {Button} from 'semantic-ui-react';

import {AddUserModal} from './AddUserModal';

type InviteTeamButtonLocalProps = {};

const InviteTeamButtonLocalComp: FC<InviteTeamButtonLocalProps> = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        color="yellow"
        onClick={() => {
          setShowModal(true);
          window.analytics?.track('Create Team Started', {
            location: 'search nav',
          });
        }}
        style={{
          padding: '6px 9px',
          alignSelf: 'center',
          margin: '0 16px 0 0 ',
        }}>
        <span style={{fontSize: '14px'}}>Invite team</span>
      </Button>
      {showModal && (
        <AddUserModal
          data-test="invite-team"
          open={showModal}
          header={<div>Invite team</div>}
          onOpen={() => setShowModal(true)}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

const InviteTeamButtonLocal = memo(InviteTeamButtonLocalComp);

export default InviteTeamButtonLocal;
